export default "__VITE_ASSET__2LNJkSbo__"